import dayjs from "dayjs";
import { useLoadBankList } from "hooks/useFactory";
import { useAppSelector } from "store";

/**
 * ใช้ total_record จาก API ตามช่วงวันที่ใน bank slice (สอดคล้องกับ ManageBank)
 */
export const useBankListTotals = () => {
  const { contact } = useAppSelector((state) => state.auth);
  const bankData = useAppSelector((state) => state.bank);

  const start_date = bankData.start_date
    ? dayjs(bankData.start_date).locale("th").format("YYYY-MM-DD")
    : "";
  const end_date = bankData.end_date
    ? dayjs(bankData.end_date).locale("th").format("YYYY-MM-DD")
    : "";

  const listInputBase = {
    start_date,
    end_date,
    offset: 0,
    limit: 1,
  };

  const { data: dataActive, isLoading: loadingActive } = useLoadBankList({
    ...listInputBase,
    status: "active",
  });

  const { data: dataInactive, isLoading: loadingInactive } = useLoadBankList({
    ...listInputBase,
    status: "inactive",
  });

  const activeBanks = Number(dataActive?.data?.total_record ?? 0);
  const inactiveBanks = Number(dataInactive?.data?.total_record ?? 0);
  const totalBanks = activeBanks + inactiveBanks;
  const isLunganek = contact?.code === "lunganek";

  return {
    totalBanks,
    activeBanks,
    inactiveBanks,
    isLunganek,
    isLoading: loadingActive || loadingInactive,
  };
};
